import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/hooks";

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  useSEO({ title: "Avis clients — Depann7", description: "Découvrez les avis de nos clients sur notre service de dépannage et remorquage en Île-de-France." });
  useEffect(() => { api.get("/reviews").then((r) => setReviews(r.data || [])).catch(() => {}); }, []);

  const avg = reviews.length ? (reviews.reduce((s, r) => s + (r.rating || 5), 0) / reviews.length).toFixed(1) : "—";

  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Avis Clients</h1>
          <div className="flex items-center gap-3 mt-4">
            <div className="text-5xl font-extrabold">{avg}</div>
            <div className="flex">{Array.from({ length: 5 }).map((_, i) => <Star key={i} size={20} className="fill-amber-400 text-amber-400" />)}</div>
            <div className="text-ink-300">basé sur {reviews.length} avis</div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.map((r, i) => (
          <div key={i} className="bg-white border border-surface-200 rounded-2xl p-6 shadow-card" data-testid={`review-${i}`}>
            <div className="flex gap-1 mb-3">{Array.from({ length: r.rating || 5 }).map((_, j) => <Star key={j} size={16} className="fill-amber-400 text-amber-400" />)}</div>
            <p className="text-txt-700 italic leading-relaxed">"{r.text}"</p>
            <div className="mt-4">
              <div className="font-bold text-txt-900">{r.name}</div>
              <div className="text-xs text-txt-500">{r.city}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
